import React from "react";
import { StriimInputField, StriimTypography } from "@striim/striim-ui";
import { styles } from "../../../common/review/review.styles";

import { Box, Grid } from "@mui/material";
import { TablesState } from "./table-mapping-editor";

interface TableEditComponentProps {
    ilTablesProperty: TablesState;
    setIlTablesProperty: React.Dispatch<React.SetStateAction<TablesState>>;
    cdcTablesProperty: TablesState;
    setCdcTablesProperty: React.Dispatch<React.SetStateAction<TablesState>>;
    showSeparateTables: boolean;
}

const TableEditComponent: React.FC = (props: TableEditComponentProps) => {
    const {
        ilTablesProperty,
        setIlTablesProperty,
        cdcTablesProperty,
        setCdcTablesProperty,
        showSeparateTables
    } = props;

    return (
        <React.Fragment>
            <Box>
                <Grid>
                    <StriimTypography variant="body4" sx={styles.targetTableTitle}>
                        {showSeparateTables ? "IL Table mapping" : ""}
                    </StriimTypography>
                </Grid>
                <StriimInputField
                    disabled={ilTablesProperty.disabled}
                    onChange={value =>
                        setIlTablesProperty(prev => ({ ...prev, changed: true, value: value, error: !value }))
                    }
                    value={ilTablesProperty.value}
                    rows={8}
                    multiline
                    type="text"
                    error={ilTablesProperty.error}
                    helperText={ilTablesProperty.error ? "Please enter a value" : ""}
                    id = {showSeparateTables ? "il-table-mapping" : "table-mapping"}
                />
            </Box>
            {showSeparateTables && (
                <Box mt={2}>
                    <Grid>
                        <StriimTypography variant="body4" sx={styles.targetTableTitle}>
                            CDC Table mapping
                        </StriimTypography>
                    </Grid>
                    <StriimInputField
                        disabled={cdcTablesProperty.disabled}
                        onChange={value =>
                            setCdcTablesProperty(prev => ({ ...prev, changed: true, value: value, error: !value }))
                        }
                        value={cdcTablesProperty.value}
                        rows={8}
                        multiline
                        type="text"
                        error={cdcTablesProperty.error}
                        helperText={cdcTablesProperty.error ? "Please enter a value" : ""}
                        id = "cdc-table-mapping"
                    />
                </Box>
            )}
        </React.Fragment>
    );
};

export default TableEditComponent;
